import styles from "./styles.module.css";
import Container from "../Container";
import Button from "../Button";
import Label from "../Label";
import ArrowLink from "../ArrowLink";
import Heading from "../Heading";
import Image from "next/image";
import Link from "next/link";
import advisors from "./advisors.jpg";
import MyImage from "../MyImage";

const ResourcesHero = ({
  title,
  slug,
  featuredImage,
  categories,
  label,
  commonFields: { authors },
  podcastFields: { participants },
}) => {
  const category = categories.nodes.length ? categories.nodes[0].name : null;

  const author =
    !!authors && authors.length
      ? authors[0].name
      : "Sustainable Capital Advisors";

  const authorImgSrc =
    !!authors && authors.length ? authors[0]?.avatar?.node?.sourceUrl : advisors;

  const participant =
    !!participants && participants.length
      ? participants[0].name
      : "Sustainable Capital Advisors";

  const participantImgSrc =
    !!participants && participants.length
      ? participants[0].avatar.node.sourceUrl
      : advisors;

  const displayAuthor = category === "Podcast" ? participant : author;

  const imgSrc = category === "Podcast" ? participantImgSrc : authorImgSrc;

  return (
    <div className={styles.resourcesHero}>
      <Container>
        <div className={styles.row}>
          <div className={styles.content}>
            <div className={styles.top}>
              {!!categories.nodes.length && <Label>{category}</Label>}
              <span className={styles.partner}>{label}</span>
            </div>
            <h2 className={styles.title}>{title}</h2>
            <div className={styles.author}>
              <div className={styles.avatarWrapper}>
                <MyImage
                  src={imgSrc}
                  width="32"
                  height="32"
                  layout="fill"
                  objectFit="cover"
                  alt="author"
                />
              </div>
              <span className={styles.authorName}>{displayAuthor}</span>
            </div>
            <Button type="green" href={`/resources/${slug}`}>
              Read more
            </Button>
          </div>
          <div className={styles.image}>
            {featuredImage && (
              <MyImage
                objectFit="cover"
                layout="responsive"
                width={featuredImage.node.mediaDetails.width}
                height={featuredImage.node.mediaDetails.height}
                src={featuredImage.node.sourceUrl}
                alt={featuredImage.node?.altText || featuredImage.node?.title}
              />
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ResourcesHero;
